export enum TabNames {
  CORRESPONDENCE = "Correspondence",
  FINANCE = "Finance",
  COMPLETION = "Completion",
}